// extracted by mini-css-extract-plugin
module.exports = {"banner":"MaintenanceBanner-module__banner--2QqHL","message":"MaintenanceBanner-module__message--2-rst"};